import React from 'react';
import DefaultLayout from '../layout/DefaultLayout';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import Breadcrumb from '../components/Breadcrumbs/Breadcrumb';

const Contacto: React.FC = () => {
  const navigate = useNavigate();
  const openLink = (url: string) => {
    window.open(url, '_blank', 'noopener');
  };

  const sendEmail = (email: string) => {
    window.location.href = `mailto:${email}`;
  };

  const makeCall = (phone: string) => {
    window.location.href = `tel:${phone}`;
  };

  return (
    <DefaultLayout>
      <Breadcrumb pageName="Contacto" />

      <div className="p-6">
        <div className="max-w-6xl mx-auto bg-white rounded-md shadow-sm p-6">

          <h2 className="text-lg font-semibold mb-2">Teléfonos útiles</h2>
          <p className="text-sm text-gray-600 mb-4">Conéctate con nosotros por cualquiera de nuestros canales</p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-bold">(0221) 423-2649</div>
                <div className="text-sm text-gray-500">Teléfono</div>
              </div>
              <button onClick={() => makeCall('02214232649')} className="text-primario-celeste-800 p-2 rounded hover:bg-primario-celeste-50">
                <FaPhone size={20} />
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-bold">(0221) 423-2650</div>
                <div className="text-sm text-gray-500">Teléfono</div>
              </div>
              <button onClick={() => makeCall('02214232650')} className="text-primario-celeste-800 p-2 rounded hover:bg-primario-celeste-50">
                <FaPhone size={20} />
              </button>
            </div>
          </div>

          <h3 className="text-base font-semibold mb-2">Correo electrónico</h3>
          <div className="space-y-3 mb-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-bold">caja@martillerosba.org.ar</div>
                <div className="text-sm text-gray-500">Correo electrónico</div>
              </div>
              <button onClick={() => sendEmail('caja@martillerosba.org.ar')} className="text-primario-celeste-800 p-2 rounded hover:bg-primario-celeste-50">
                <FaEnvelope size={18} />
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-bold">colegio@martillerosba.org.ar</div>
                <div className="text-sm text-gray-500">Correo electrónico</div>
              </div>
              <button onClick={() => sendEmail('colegio@martillerosba.org.ar')} className="text-primario-celeste-800 p-2 rounded hover:bg-primario-celeste-50">
                <FaEnvelope size={18} />
              </button>
            </div>
          </div>

          <div className="flex items-start justify-between mb-6">
            <div>
              <h3 className="text-base font-semibold">Oficina</h3>
              <div className="text-sm font-bold">Calle 46 N° 536 - La Plata</div>
              <div className="text-sm text-gray-500">Lunes a viernes de 7:30 a 14:30hs</div>
            </div>
            <button
              onClick={() => openLink('https://maps.google.com/?q=Calle+46+N%C2%BA+536+La+Plata')}
              className="text-primario-celeste-800 p-2 rounded hover:bg-primario-celeste-50"
            >
              <FaMapMarkerAlt size={20} />
            </button>
          </div>

          <h3 className="text-base font-semibold mb-1">Redes sociales</h3>
          <p className="text-sm text-gray-500 mb-3">También podes seguirnos en nuestras redes sociales</p>

          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <button onClick={() => openLink('https://www.facebook.com/MartillerosBA')} className="text-primario-celeste-800 hover:text-primario-celeste-900">
                <FaFacebookF size={20} />
              </button>
              <button onClick={() => openLink('https://www.instagram.com/martilleros.ba')} className="text-primario-celeste-800 hover:text-primario-celeste-900">
                <FaInstagram size={20} />
              </button>
              <button onClick={() => openLink('https://www.twitter.com/martillerosba')} className="text-primario-celeste-800 hover:text-primario-celeste-900">
                <FaTwitter size={20} />
              </button>
              <button onClick={() => openLink('https://www.youtube.com/channel/UCsZ6tWjsWPzZvVGSEu8_-ig/featured')} className="text-primario-celeste-800 hover:text-primario-celeste-900">
                <FaYoutube size={20} />
              </button>
              <div className="ml-3 text-sm font-semibold">MartillerosBA</div>
            </div>
          </div>

        </div>

        <div className="flex gap-3 justify-center mt-3">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded"
          >
            Volver
          </button>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default Contacto;